import React, { useState } from "react";
import auth from "../../providers/Auth.Provider";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import { useQuery, useMutation } from "react-apollo";
import TextInput from "./partials/Textinput";
import { Staff as STAFFQUERY, NEWSTAFFINFO } from "../../queries/staff.query";
import DropdownInput from "./partials/DropdownInput";
import LoadingSpinner from "../../partials/loading";
import ImageUpload from "./partials/ImageUpload";
import { toast } from "react-toastify";
import { sendNotification } from "../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

import dummyImage from "../../img/image.png";
import { CleanMessage } from "../../util/app";

const EditStaff = ({ location, history }) => {
    const [staff, UpdateStaff] = useState(location.state.activeStaff);

    const title = "Edit Staff Info";

    // Get authenticated user site
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();

    // Query Get Staff Information objects
    const { loading, data } = useQuery(NEWSTAFFINFO, {
        variables: {
            siteId: site && site.id,
            site: site && site.id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // Query to add new staff
    const [UpdateStaffInfo, { loading: uLoading }] = useMutation(STAFFQUERY.MUTATION.UPDATESTAFF, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.UpdateStaffProfile;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.STAFF);
        },
    });

    const designation = data && data.GetAllDesignation.docs;

    const departments = data && data.GetDepartments.docs;

    const staffType = data && data.GetAllStaffType.docs;

    const gender = [
        {
            id: "1",
            name: "Male",
        },
        {
            id: "2",
            name: "Female",
        },
        {
            id: "3",
            name: "Others",
        },
    ];

    // Gets Gender object from gender name of active Staff
    const GetActiveGender = (name) => {
        let activeGender = gender.forEach((g) => g.name.toLowerCase() === name.toLowerCase());
        return activeGender;
    };

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <div className="row">
                <div className="col-md-12 col-sm-12">
                    <div className="card card-box">
                        <div className="card-body" id="bar-parent">
                            <form
                                className="form-horizontal"
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    let model = {};
                                    // update =
                                    model.id = staff.id;
                                    model.first_name = staff.first_name;
                                    model.middle_name = staff.middle_name;
                                    model.surname = staff.surname;
                                    model.mobile = staff.mobile;
                                    model.designation = staff.designation.id;
                                    model.department = staff.department.id;
                                    model.type = staff.type.id;
                                    model.gender = staff.gender;
                                    model.image = staff.image;

                                    await UpdateStaffInfo({
                                        variables: {
                                            staff: model,
                                            id: staff.id,
                                        },
                                    });

                                    setTimeout(() => {
                                        history.goBack();
                                    }, 500);
                                }}
                            >
                                <div className="text-center mt-5">
                                    <center>
                                        <div
                                            style={{
                                                backgroundImage: `url(${staff.image || dummyImage}`,
                                                width: "100px",
                                                height: "100px",
                                            }}
                                            className="img-container user-img-circle"
                                        ></div>
                                        <h4>Profile Picture</h4>
                                    </center>
                                </div>
                                <div className="form-body">
                                    <TextInput
                                        title="First Name"
                                        currentValue={staff.first_name}
                                        placeholder="Enter first name"
                                        isRequired={true}
                                        onValueChange={(first_name) =>
                                            UpdateStaff({
                                                ...staff,
                                                first_name,
                                            })
                                        }
                                    />
                                    <TextInput
                                        title="Middle Name"
                                        currentValue={staff.middle_name}
                                        placeholder="Enter middle name"
                                        onValueChange={(middle_name) =>
                                            UpdateStaff({
                                                ...staff,
                                                middle_name,
                                            })
                                        }
                                    />
                                    <TextInput
                                        title="Last Name"
                                        currentValue={staff.surname}
                                        placeholder="Enter last name"
                                        isRequired={true}
                                        onValueChange={(surname) =>
                                            UpdateStaff({
                                                ...staff,
                                                surname,
                                            })
                                        }
                                    />
                                    <TextInput
                                        title="NI Number"
                                        type="text"
                                        currentValue={staff.nin}
                                        isRequired={true}
                                        placeholder="Enter NI number"
                                        onValueChange={(nin) =>
                                            UpdateStaff({
                                                ...staff,
                                                nin,
                                            })
                                        }
                                    />
                                    <TextInput
                                        title="Phone Number"
                                        currentValue={staff.mobile}
                                        placeholder="Enter phone number"
                                        isRequired={true}
                                        onValueChange={(mobile) =>
                                            UpdateStaff({
                                                ...staff,
                                                mobile,
                                            })
                                        }
                                    />
                                    <DropdownInput
                                        title="Gender"
                                        items={gender}
                                        activeObj={GetActiveGender(staff.gender)}
                                        isRequired={true}
                                        onValueChange={(gender) =>
                                            UpdateStaff({
                                                ...staff,
                                                gender: gender && gender.name,
                                            })
                                        }
                                    />
                                    <DropdownInput
                                        title="Type"
                                        items={staffType}
                                        activeObj={staff.type}
                                        onValueChange={(type) =>
                                            UpdateStaff({
                                                ...staff,
                                                type,
                                            })
                                        }
                                    />
                                    <DropdownInput
                                        title="Designation"
                                        items={designation}
                                        activeObj={staff.designation}
                                        onValueChange={(designation) =>
                                            UpdateStaff({
                                                ...staff,
                                                designation,
                                            })
                                        }
                                    />
                                    <DropdownInput
                                        title="Department"
                                        items={departments}
                                        activeObj={staff.department}
                                        onValueChange={(department) =>
                                            UpdateStaff({
                                                ...staff,
                                                department,
                                            })
                                        }
                                    />
                                    <ImageUpload
                                        title="Change Profile Picture"
                                        onData={(cb) =>
                                            UpdateStaff({
                                                ...staff,
                                                image: cb.path,
                                            })
                                        }
                                    />

                                    <div className="text-center mt-5">
                                        <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                                            Submit
                                            <i className="material-icons">arrow_right_alt</i>
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                history.goBack();
                                            }}
                                            className="mdl-button mdl-button--raised mdl-js-ripple-effect ml-2 btn-circle btn-default"
                                        >
                                            <i className="material-icons text-danger">cancel</i>
                                            Cancel
                                        </button>
                                    </div>
                                    {/* Loading spinner for getting staff info objects */}
                                    <LoadingSpinner loading={loading} />

                                    {/* Loading spinner for updating staff info */}
                                    <LoadingSpinner loading={uLoading} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditStaff;
